import React from "react";
import {cx} from "../../../lib/ClassSet";
import "./ShopItem.css";

const ShopItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "sales-shop-list-item": true,
    "u-selected": props.selected
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id" onClick={(e) => props.onClick(data, e, "shopId")}>{data.get("shopId")}</td>
      <td className="field f-title">{data.get("title")}</td>
      <td className="field f-currencies">{data.get("currencies")}</td>
    </tr>
  )
}

export default ShopItem;